module.exports = __webpack_public_path__ + "static/media/md-help-buoy.3748193b.svg";